import { useEffect, useState } from 'react';

import DiscountFormModal from './DiscountFormModal';
import {
  deleteDiscount,
  getDiscounts,
  toggleDiscount,
} from '../../api/discounts.api';

export default function DiscountList() {
  const [loading, setLoading] = useState(true);
  const [discounts, setDiscounts] = useState([]);
  const [selected, setSelected] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    load();
  }, []);

  async function load() {
    setLoading(true);
    const res = await getDiscounts();
    setDiscounts(res.data.list || []);
    setLoading(false);
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-xl font-bold">مدیریت کدهای تخفیف</h1>

        <button
          onClick={() => {
            setSelected(null);
            setShowModal(true);
          }}
          className="px-4 py-2 bg-blue-600 text-white rounded-xl">
          ساخت کد جدید
        </button>
      </div>

      {loading ? (
        <p>در حال بارگذاری...</p>
      ) : (
        <table className="w-full border rounded-xl bg-white shadow">
          <thead className="bg-gray-100 text-sm">
            <tr>
              <th className="p-3">کد</th>
              <th className="p-3">نوع</th>
              <th className="p-3">مقدار</th>
              <th className="p-3">محصول</th>
              <th className="p-3">انقضا</th>
              <th className="p-3">وضعیت</th>
              <th className="p-3">عملیات</th>
            </tr>
          </thead>

          <tbody>
            {discounts.map((d) => (
              <tr key={d._id} className="text-center border-t">
                <td className="p-3 font-bold">{d.code}</td>
                <td className="p-3">
                  {d.type === 'percent' ? 'درصدی' : 'مبلغ ثابت'}
                </td>
                <td className="p-3">{d.value}</td>
                <td className="p-3">{d.global ? 'تمام محصولات' : d.product}</td>
                <td className="p-3">
                  {d.expiresAt
                    ? new Date(d.expiresAt).toLocaleDateString('fa-IR')
                    : '-'}
                </td>

                <td className="p-3">
                  <span
                    className={`px-3 py-1 rounded-full text-xs ${
                      d.active
                        ? 'bg-green-100 text-green-700'
                        : 'bg-red-100 text-red-700'
                    }`}>
                    {d.active ? 'فعال' : 'غیرفعال'}
                  </span>
                </td>

                <td className="p-3 flex justify-center gap-2">
                  {/* Edit */}
                  <button
                    onClick={() => {
                      setSelected(d);
                      setShowModal(true);
                    }}
                    className="px-3 py-1 text-xs bg-yellow-500 text-white rounded-xl">
                    ویرایش
                  </button>

                  {/* Toggle */}
                  <button
                    onClick={async () => {
                      await toggleDiscount(d._id);
                      load();
                    }}
                    className="px-3 py-1 text-xs bg-blue-500 text-white rounded-xl">
                    فعال/غیرفعال
                  </button>

                  {/* Delete */}
                  <button
                    onClick={async () => {
                      if (window.confirm('حذف شود؟'))
                        await deleteDiscount(d._id);
                      load();
                    }}
                    className="px-3 py-1 text-xs bg-red-500 text-white rounded-xl">
                    حذف
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Modal */}
      {showModal && (
        <DiscountFormModal
          onClose={() => setShowModal(false)}
          onSaved={() => {
            setShowModal(false);
            load();
          }}
          data={selected}
        />
      )}
    </div>
  );
}
